<template>
  <div class="index-module_articleWrap_2Zphx" style="text-indent:0;">
      <p class="zhemo">
          了解多因子策略
        </p>
        <p  class="text_content">
          多因子策略，研究对象是包含多只股票的一个股票池，可用数据不仅仅局限于k线图和技术分析指标，还可以利用财务数据、经营数据、基本面资料，以及换手率、波动率、资金流入等市场统计数据，通过综合统计分析，找出一些符合条件的股票，买入，长期持有，通过跟随股票价格的上涨，来实现账户的净值增长，属于选股的范畴。持仓的股票是动态的，滚动更新，加入符合条件的新股票，剔除不符合条件的旧股票。剔除一只股票不是因为这只股票大幅上涨而止盈，也不是因为这只股票大幅下跌而止损，而是因为这只股票不再符合持有条件。
        </p>
        <p class="text_content">
          多因子策略是没有交易指令的，由多个因子的组合生成持有股票的综合条件。买入根据这个条件，卖出也根据这个条件，买入或继续持有那些满足条件的股票，卖出那些不再满足条件的股票。
        </p>
        <p class="free">（原创）</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

  .service_content{
    width: 990px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px -5px #ccc; 
    min-height: 600px;
    padding-bottom: 50px;
  }
  .service_content .title{
    color: #5f5f5f;
    border-bottom: 1px dashed #a8a8a8;
    line-height: 40px;
    font-size: 22px;
  }
  .text_content{
    text-indent: 2em;
    font-size: 14px;
    line-height: 20px;
    color:#6f6f6f;
    padding: 10px 0;
    text-align: justify;
  }
  .title2{
    font-size: 16px;
    color: #5d0f0b;
    border-left: 4px solid #e24a49;
    font-weight: bold;
    padding-left: 10px;
    margin: 15px 0;
  }
  #table {
			width: 590px;
			margin: 20px auto;
            color: #6f6f6f;
            font-size: 15px;
            text-align: center !important;
		}
#table td{
line-height: 40px;

}
		/*第一种颜色*/
		#table tr.color1 {
			background-color: #FFFFFF;
		}

		/*第二种颜色*/
		#table tr.color2 {
			background-color: #F8F8F8;
		}

		#table td.teacher {
			background-color: #fff;
		}

		#table td.date {
			background-color: #F0F0F0;
		}

		#table td.time {
			background-color: #f8f8f8;
		}
		#table .header{
			color: #fff;
		}
		#table td.time p {
			margin: 0;
			padding: 0;
		}

		#table td span {
			/*margin-left:5px;*/
		}
		/* #table td {
			border-color: 1px solid #bfbfbf;
		} */
        .bBlackBorder {
			border-bottom: 1px solid #bfbfbf;
		}

		.rBlackBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bGreyBorder {
			border-bottom: 1px solid #BFBFBF;
		}

		.rLightBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bLightBorder {
			border-bottom: 1px solid #bfbfbf;
		}
		.tLightBorder{
			border-top: 1px solid #bfbfbf;
		}
		.lLightBorder{
			border-left: 1px solid #bfbfbf;
		}
</style>